import { IResTheme, IResThemeMode } from 'types/api';
import { IAppThemeMode, IAppTheme } from 'types/theme';

const extractFont = (fontVarStr: string) => {
	const font = fontVarStr
		.replace('var(--descope-fonts-', '')
		.replace('-family)', '');
	if (font === 'font1' || font === 'font2') {
		return font;
	}
	/* istanbul ignore next */
	return null;
};

const convertThemeMode = (codeThemeMode: IResThemeMode): IAppThemeMode => ({
	logoUrl: codeThemeMode.components?.logo?.['--descope-logo-url'],
	faviconUrl: codeThemeMode.components?.logo?.favicon,
	colors: {
		primary: codeThemeMode.globals?.colors?.primary
	},
	fonts: codeThemeMode.globals?.fonts,
	typography: Object.fromEntries(
		Object.entries(codeThemeMode.globals?.typography || {}).map(
			([variant, overrides]) => [
				variant,
				{
					...overrides,
					font: overrides.font ? extractFont(overrides.font) : null
				}
			]
		)
	)
});

export const convertTheme = (codeTheme: IResTheme): IAppTheme => {
	const res = {
		light: convertThemeMode(codeTheme.light),
		dark: convertThemeMode(codeTheme.dark)
	};

	return res;
};
